export const GET_NOTIFICATIONS_LIST_PAGE = 'GET_NOTIFICATIONS_LIST_PAGE';
export const GET_NOTIFICATIONS_LIST_PAGE_SUCCESS =
    'GET_NOTIFICATIONS_LIST_PAGE_SUCCESS';
export const GET_NOTIFICATIONS_PAGE_ERROR = 'GET_NOTIFICATIONS_PAGE_ERROR';
